module.exports = __webpack_public_path__ + "static/media/imageUpload.863cdd40.svg";